import { makeStyles } from "@material-ui/core"

import { AlertContainerStyleProps } from "@/components/AlertContainer"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

type StylesProps = AlertContainerStyleProps

const useStyles = (props: StylesProps) => makeStyles({
	container: {
		borderLeft: "4px solid",
		borderLeftColor: props.borderLeftColor,
		borderRadius: "8px",
		padding: "16px",
		...ColorUtil.getBackgroundAndContrastColor(props.containerBackgroundColor),
		gap: "12px",
		boxShadow: `2px 5px 10px 8px ${colors.gray[100]}`
	},
	title: {
		fontSize: "16px",
		fontWeight: 700,
		lineHeight: "24px",
		...ColorUtil.getBackgroundAndContrastColor(props.containerBackgroundColor)
	}
})(props)

export default useStyles
